import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { Empty } from '@buildoutinc/blueprint-react/ui/Empty';

export default function NoLeads({ bodyText }) {
  return (
    <Empty className="bg-white">
      <Empty.Media>
        <FontAwesomeIcon icon={faExclamationCircle} />
      </Empty.Media>
      <Empty.Title>You have not created any leads</Empty.Title>
      <Empty.Content>{bodyText}</Empty.Content>
    </Empty>
  );
}

NoLeads.propTypes = {
  bodyText: PropTypes.string,
  emptyLeadsImage: PropTypes.string
};
